import React from 'react';
// redux
import { connect } from 'react-redux';
import { openModal } from '../../../redux/reducers/modal';
// utils
import { getEvent } from '../utils';
// components
import Icon from '../../Icon/Icon';
// shapes
import eventsShape from '../../../shapes/events';
// styles
import styles from './Events.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const Events = ({ selectedDay, events, color, showCalendar, openModal }) => {
  const updateSkill = skill => () => {
    showCalendar();
    openModal('UPDATE_SKILL', { skill, color });
  };
  const deleteSkill = skill => () => {
    showCalendar();
    openModal('DELETE_SKILL', { skill, color });
  };

  return (
    <div className={cx('day-events')}>
      {events.map((skill, index) => {
        const { title, skill_dates } = skill;
        const hasEvent = getEvent({ date: selectedDay, event: skill_dates[0] });
        return hasEvent ? (
          <div key={index} className={cx('container')}>
            <div className={cx('event-container', 'fadeIn')}>
              <span>{title}</span>
              <div className={cx('buttons-container')}>
                <button
                  className={cx('button', 'hint--bottom-left')}
                  onClick={updateSkill(skill)}
                  data-hint="Edit"
                >
                  <Icon
                    type="pen"
                    color="black"
                    className={cx('button-icon')}
                  />
                </button>
                <button
                  onClick={deleteSkill(skill)}
                  className={cx('button', 'hint--bottom-left')}
                  data-hint="Delete"
                >
                  <Icon
                    type="delete"
                    color="red"
                    className={cx('button-icon')}
                  />
                </button>
              </div>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
};

Events.propTypes = eventsShape;

export default connect(
  null,
  { openModal }
)(Events);



// WEBPACK FOOTER //
// ./src/components/Calendar/components/Events.jsx